import { css } from '@emotion/react'
import {
  Color,
  Size,
  Spacing,
  Theme,
  Transition,
  Typography,
  ZIndex,
} from '@opallabs/gem'

export const URLInputStyleStates = {
  disabled: 'disabled',
  hasValue: 'has-value',
}
export const URLInputStyleSelectors = {
  root: 'lapidary-url-input',
}

export const openUrlLink = (theme: Theme) =>
  css({
    ...Typography.T500,
    alignItems: 'center',
    blockSize: 24,
    backgroundColor: Color[theme].Surface.A000,
    border: '1px solid',
    borderRadius: Size.Rounding,
    borderColor: Color[theme].Surface.A100,
    color: Color[theme].Text.Accent,
    display: 'flex',
    flexShrink: 0,
    inlineSize: 47,
    justifyContent: 'center',
    textDecoration: 'none',
    ...Transition(['border-color', 'box-shadow', 'opacity']),

    '&:focus, &:hover': {
      display: 'flex',
      backgroundColor: Color[theme].Translucent.N48,
    },

    '&:active': {
      backgroundColor: Color[theme].Translucent.N72,
    },
  })

export const urlInputContainer = ({
  disablePopover,
  expanded,
  theme,
}: {
  disablePopover?: boolean
  expanded: boolean
  theme: Theme
}) =>
  css({
    position: 'relative',

    '&:not(.disabled):hover': {
      backgroundColor:
        expanded || disablePopover
          ? Color[theme]['Color/Surface/Surface-1']
          : Color[theme]['Color/Surface/Surface-2'],
      borderRadius: Size.Rounding,
    },
  })

export const openUrlContainer = css({
  position: 'absolute',
  right: Spacing.S,
  top: 6,
  zIndex: ZIndex.Element.Level1,
})

export const readOnlyText = ({
  showingPlaceholder,
  theme,
}: {
  showingPlaceholder: boolean
  theme: Theme
}) =>
  css({
    blockSize: 36,
    color: showingPlaceholder
      ? Color[theme]['Text/Secondary']
      : Color[theme]['Text/Links'],
    display: 'block',
    lineHeight: '36px',
    overflow: 'hidden',
    paddingInline: Spacing.S + 1,
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
    width: 'calc(100% - 55px)',
  })
